module.exports = __webpack_public_path__ + "img/b6-1.c0a57a6.svg";